<template>
    <select
        :value="selected"
        :class="{ 'text-bold': selectedOption }"
        class="select-filter-mobile text-uppercase"
        @change="fetch($event.target.value)"
    >
        <template v-if="!secondOptions">
            <option :value="undefined" v-show="showFirstOption">{{ label }}</option>
            <option v-for="option in options" :key="option.id" :value="option['url']">
                {{ option.name }}
            </option>
        </template>
        <template v-if="secondOptions">
            <option :value="undefined" v-show="showFirstOption">{{ label }}</option>
            <optgroup label="ADULTO">
                <option v-for="option in options" :key="option.id" :value="option['url']">
                    {{ option.name }}
                </option>
            </optgroup>
            <optgroup label="INFANTIL">
                <option v-for="option in secondOptions" :key="option.id" :value="option['url']">
                    {{ option.name }}
                </option>
            </optgroup>
        </template>
    </select>
</template>

<script>
    import { catalogStore } from '../../common/store/catalog-store';

    export default {
        name: 'CatalogFilterGroupMobile',

        props: {
            label: {
                type: String,
                required: true,
            },
            options: {
                type: Array,
                required: true,
            },
            secondOptions: {
                type: Array,
                required: false,
            },
            urlParam: {
                type: String,
                required: true,
            },
            selected: {
                type: String | Number,
                required: false,
            },
            handleFetch: {
                type: Boolean,
                default: true,
            },
            showFirstOption: {
                type: Boolean,
                default: true,
            },
            isColor: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {};
        },

        mounted() {},

        computed: {
            selectedOption() {
                return this.options.find((o) => (o['url'] || null) === (this.selected || null));
            },
        },

        methods: {
            fetch(new_url) {
                const url = catalogStore.buildUrl(this.urlParam, new_url, new_url, !new_url);

                window.dataLayer.push({
                    event: 'clickOnCatalogFilter',
                });

                // Carregamento dinâmico se a API pushState estiver disponível
                if (typeof history.pushState !== 'function') return true;

                if (this.handleFetch) {
                    catalogStore.fetch(this.axios, url);
                } else {
                    this.$emit('fetch', url);
                }
            },

            codeHex(option) {
                return '#' + option.rgb;
            },
        },
    };
</script>
